import { render, staticRenderFns } from "./BrandsStats.vue?vue&type=template&id=e16edae0&"
import script from "./BrandsStats.vue?vue&type=script&lang=js&"
export * from "./BrandsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports